export default __webpack_public_path__ + "static/media/ero_blink.9c4995ec.gif";